import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router, NavigationEnd} from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../services/user-verification.service";
import {KeycloakService} from "../services/keycloak.service";
import {NgForm} from "@angular/forms";
import {HttpService} from "../services/http.service";
import {RoamingPartnersComponent} from '../roaming-partners/roaming-partners.component';
import {ServingJoinServersComponent} from '../serving-join-servers/serving-join-servers.component';
import {GroupNetworkServersComponent} from '../group-network-servers/group-network-servers.component';
import {MessageLogsComponent} from '../message-logs/message-logs.component';
import {DateUtils} from "../services/date-utils";
import {StringUtils} from "../services/string-utils";
import {ApiEndpoints} from "../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-get-all-network-server-groups-detail',
  templateUrl: './get-all-network-server-groups-detail.component.html',
})
export class GetAllNetworkServerGroupsDetailComponent implements OnInit, OnDestroy {

  isAdmin: boolean = false;
  username: string = KeycloakService.username;
  id: any;
  listInfo: Object = {};
  listStatus: Object;

  listGroupNetworkServers: any[];
  listServingJoinServers: any[];
  listRoamingPartners: any[];

  hasAcces: boolean;
  errorStatus: number;
  errorText: string;

  public createRP = true;
  public strOwnership = "";
  public userUrl = ApiEndpoints.GET_USER;
  public logsUrl = ApiEndpoints.GET_NETWORK_SERVER_GROUP_LOGS;

  httpSubscription: Subscription;

  @ViewChild('validate') validate: NgForm;
  @ViewChild(RoamingPartnersComponent) roamingPartnersComponent:RoamingPartnersComponent;
  @ViewChild(ServingJoinServersComponent) servingJoinServersComponent: ServingJoinServersComponent;
  @ViewChild(GroupNetworkServersComponent) groupNetworkServersComponent: GroupNetworkServersComponent;
  @ViewChild(MessageLogsComponent) messageLogsComponent: MessageLogsComponent;

  constructor(private route: ActivatedRoute,
                private router: Router,
                private http: HttpClient,
                private userVerificationService: UserVerificationService,
                private httpService: HttpService) {

    this.isAdmin = this.userVerificationService.isAdmin;
    //get URL parameters
    this.route.params.subscribe(params => {
      window.scrollTo(0, 0);
      this.id = params['virtId'];
      this.httpSubscription = this.httpService.getNetworkServerGroupInfo(this.id)
        .subscribe((data: any) => {
          this.listInfo = data;
          if (data.username == 'Default') {
            this.username = '';
          } else {
            this.username = data.username;
            if (data.affiliation !== undefined && data.affiliation !== "") {
              this.strOwnership = data.username + ' / ' + data.affiliation;
            } else {
              this.strOwnership = data.username;
            }
          }
          this.hasAcces = true;
          this.getAllNetworkServerDetails();
          this.getNetworkServiceName(data.name);
        },
        (err) => {
          this.hasAcces = false;
          this.errorStatus = err.status;
          this.errorText = err.statusText;
        });
    });
  }

  getAllNetworkServerDetails() {

  }


  getNetworkServiceName(networkName) {
    var serverName = networkName;
    $("#menu0sub1").remove();
    var html = '<div class="collapse show width-100-perc" id="menu0sub1"><a class="list-group-item transition item-sub sub active" data-parent="#menu0sub1">' + serverName + '</a></div>';
    $(".network-server-groups").after(html);
  }

  insertSpacesBetweenIds(ids: Array<string>) {
    return StringUtils.insertSpacesBetweenIds(ids);
  }

  roamingPartnersLoaded(partners) {
    this.listRoamingPartners = partners;
  }

  servingJoinServersLoaded(servingJSs) {
    this.listServingJoinServers = servingJSs;
  }

  groupNetworkServersLoaded(groupNSs) {
    this.listGroupNetworkServers = groupNSs;
  }

  refreshSubComponents(vId) {
    var end = DateUtils.addDays(new Date(), 1);
    var start = DateUtils.subtractDays(end, 3);
    // TODO: Investigate how to do refresh on subcomponent
    this.groupNetworkServersComponent.GroupNetworkServers(vId);
    this.roamingPartnersComponent.RoamingPartners(vId);
    this.servingJoinServersComponent.ServingJoinServers(vId);
    this.roamingPartnersComponent.getAllNetworkServerWithoutRoamingRelationship(vId);
    this.servingJoinServersComponent.getAllJoinServersWithoutActivationAgreement(vId);
    this.messageLogsComponent.LogsNsGroup(this.listInfo['netIds'], start.getTime().toString(), end.getTime().toString());
  }

  ngOnInit() {
    $(document).on("click", ".network-server-groups", function (e) {
      $("#menu0sub1").remove();
      $("#menu1sub1").remove();
      $("#menu2sub1").remove();
      $("#menu1").removeClass("show");
      $("#menu2").removeClass("show");
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.refreshSubComponents(this.id);
    });
  }

  ngOnDestroy() {
      $("#menu0sub1").removeClass("show");
  }

}
